import { Modal } from '@ui-kitten/components';
export default Modal;
//# sourceMappingURL=Modal.js.map